import React from "react";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faBars } from "@fortawesome/free-solid-svg-icons";

import AuthenticationButton from "../components/buttons/AuthenticationButton";

import Logo from "../assets/llh-logo.png";
import styles from "./Header.module.css";

const Header = ({ toggleMenu, mobileView }) => {
  const logout = () => {
    localStorage.removeItem("apiKey");
    window.location = "/login";
  };

  return (
    <div className={styles.header}>
      <div className={styles.header__content}>
        <div className={styles.header__brand}>
          {mobileView ? (
            <button
              onClick={toggleMenu}
              className={styles.header__burger__bar__btn}
            >
              <FontAwesomeIcon
                className={styles.header__burger__bar__icon}
                icon={faBars}
                color={"black"}
              />
            </button>
          ) : null}
          <Link to="/">
            <img src={Logo} alt="llh-logo" className={styles.header__logo} />
            <p className={styles.header__brandName}>LLH WOW</p>
          </Link>
        </div>

        <div className={styles.header__action}>
          <AuthenticationButton />
        </div>
      </div>
    </div>
  );
};

export default Header;
